<div class="container">
  <div class="row justify-content-center">
    <h1>Error page</h1>

    <button (click)="generateError()" class="btn btn-danger">Generate error</button>
  </div>
</div>

